module.exports = __webpack_public_path__ + "img/reddanger.312c8690.svg";